// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 12) return "static/js/aff06bbbf9bd38e99770.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"36bf746aca800c1e24a9","121":"d5ee6eefc09585f2163e","122":"f234661564eba994e888"}[chunkId] + ".chunk.js";
};